
export const POLICY_RES_NAME_KEY_MAP = {
  vminstance: { key: 'vminstance', service: 'compute', resource: 'servers' },
}

export const POLICY_WHITE_LIST = ['set-user-metadata']
